module.exports = __webpack_public_path__ + "static/media/envelope.d4a4f1d4.svg";